import { Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import { useAuth } from "./hooks/useAuth";
import { useGlobalState } from "./state";

export default function StudioLayout() {
  const { isAuthenticated } = useAuth();
  const { theme } = useGlobalState();

  return (
    <div className={`flex flex-col h-screen w-full ${theme}`}>
      {/* Navbar */}
      {isAuthenticated && <Navbar />}
      {/* Content */}
      <div
        className={`flex bg-slate-200 flex-1 px-4 sm:px-6 lg:px-8 py-4 pt-4 ${
          isAuthenticated ? "pb-4" : "pb-8"
        }`}
      >
        <Outlet />
      </div>
      {!isAuthenticated && (
        <div className="text-slate-400 bg-slate-200 flex justify-center p-8 space-x-1">
          <div>Powering </div>
          <a
            href="https://ktr.studio"
            className="font-medium text-red-600 hover:text-red-500"
          >
            KTR Studio
          </a>
        </div>
      )}
    </div>
  );
}
